import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.mjs?url';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export async function generatePdfThumbnail(pdfUrl: string): Promise<string> {
  try {
    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);


    // Calculate scale to fit 200px max width/height while maintaining aspect ratio
    const unscaledViewport = page.getViewport({ scale: 1 });
    const maxDim = 200;
    const scale = Math.min(maxDim / unscaledViewport.width, maxDim / unscaledViewport.height);
    const viewport = page.getViewport({ scale });

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) {
      throw new Error('Could not get canvas context');
    }

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport: viewport,
    };

    await page.render(renderContext).promise;

    return canvas.toDataURL('image/jpeg', 0.7);
  } catch (error) {
    console.error('Error generating PDF thumbnail:', error);
    throw error;
  }
}

export function isPdfFile(url: string): boolean {
  return url.toLowerCase().endsWith('.pdf') || url.includes('.pdf?');
}

export function dataURLtoBlob(dataurl: string) {
  const arr = dataurl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) return new Blob();
  const mime = mimeMatch[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}
